<template>
  <div class="resume-train-experience-wrap clearfix" v-if="train&&train.length">
    <div class="progress-content">
      <ul>
        <li class="clearfix" v-for="(item,index) in train" :key="index">
          <em></em>
          <i></i>
          <div class="info-box">
            <p>{{item | dateAndRange}}</p>
            <p v-if="item.course" v-html="item.course"></p>
            <p v-if="item.agencyName" v-html="item.agencyName"></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped lang="scss">
.resume-train-experience-wrap {
  .progress-content{
    >ul{
      >li{
        .info-box{
          margin-left: 0;
        }
      }
    }
  }
}
</style>
<script>
export default {
  props:{
    train: {}
  },
  data(){
    return{
    };
  },
  components: {
  },
  methods: {
  },
  created() {
  }
};
</script>
